import { SET_COIN, ADD_COIN } from '../config/actionTypes';

const initialState = [
	{ key: 'Bitcoin', value: 'btc' },
	{ key: 'Ethereum', value: 'eth' },
	{ key: 'Ripple', value: 'xrp' },
	{ key: 'HollaEx', value: 'xht' },
	{ key: 'USDT', value: 'usdt' }
];

const StatReducer = (state = initialState, action) => {
	const { data, type } = action;
	switch (type) {
		case SET_COIN:
			return data;
		case ADD_COIN:
			return [
				...state,
				data
			];
		default:
			return state;
	}
};

export default StatReducer;
